import { useQuery } from '@tanstack/react-query';
import { authFetch } from '@/services/api';

export interface SuspendedRun {
  runId: string;
  workflowName: string;
  suspendPayload: Record<string, any>;
  displayInfo: {
    action: string;
    message: string;
    summary?: Record<string, any>;
    reservationId?: string;
    guestName?: string;
  };
  createdAt: string;
}

export function usePendingWorkflows(enabled = true) {
  return useQuery<SuspendedRun[]>({
    queryKey: ['mastra', 'pending'],
    queryFn: async () => {
      const res = await authFetch('/mastra/pending');
      if (!res.ok) throw new Error('Failed to fetch pending workflows');
      const data = await res.json();
      return Array.isArray(data) ? data : (data.value ?? []);
    },
    refetchInterval: 10000,
    enabled,
  });
}

export function usePendingWorkflowCount() {
  const { data } = usePendingWorkflows();
  return data?.length ?? 0;
}
